<template>
    <div id="admin_wallet_errors">
        <div class="accordion accordion-toggle-arrow" id="userErrorFilter">
            <div class="card" style="overflow:inherit">
                <div class="card-header bg-transparent" id="headingOne">
                    <div class="card-title collapsed" data-toggle="collapse"
                         data-target="#filterErrorForm"
                         aria-controls="filterErrorForm">
                        {{ $t('label.search') }}
                    </div>
                </div>
                <kt-panel>
                    <div id="filterErrorForm" class="collapse" aria-labelledby="filterErrorForm" data-parent="#userErrorFilter">
                        <div class="card-body">
                            <form @submit.prevent="filterAction($event, query)" id="error_form_filter">
                                <kt-form-section>
                                    <kt-form-row>
                                        <kt-col xs="12" sm="3" md="3" class="mb-2">
                                            <kt-form-group ref="typeSelectGroup">
                                                <kt-form-label for="type">
                                                    {{ $t('label.wallet_errors_columns.type') }}
                                                </kt-form-label>
                                                <kt-form-select size="5" id="type" class="form-control"
                                                                name="type" v-model="query.type"
                                                >
                                                    <option :value="null" v-text="$t('selectpicker.select_all')"
                                                    ></option>
                                                    <option v-for="(type, index) in walletErrorTypes"
                                                            :value="type"
                                                            :key="index"
                                                            v-text="walletErrorTypesStr.get(type)"
                                                    ></option>

                                                </kt-form-select>
                                            </kt-form-group>
                                        </kt-col>
                                        <kt-col xs="12" sm="3" md="3" class="mb-2">
                                            <kt-form-group ref="statusSelectGroup">
                                                <kt-form-label for="status">
                                                    {{ $t('label.wallet_errors_columns.status') }}
                                                </kt-form-label>
                                                <kt-form-select size="5" id="status" class="form-control"
                                                                name="status" v-model="query.status"
                                                >
                                                    <option :value="null" v-text="$t('label.all_statuses')"
                                                    ></option>
                                                    <option v-for="(status, index) in walletErrorStatus"
                                                            :value="status"
                                                            :key="index"
                                                            v-text="walletErrorStatusStr.get(status)"
                                                    ></option>
                                                </kt-form-select>
                                            </kt-form-group>
                                        </kt-col>
                                        <kt-col xs="12" sm="3" md="3" class="mb-2">
                                            <kt-form-group ref="statusSelectGroup">
                                                <kt-form-label for="status">
                                                    {{ $t('label.wallet_errors_columns.reason_title') }}
                                                </kt-form-label>
                                                <kt-form-select size="5" id="reason" class="form-control"
                                                                name="reason" v-model="query.reason"
                                                >
                                                    <option :value="null" v-text="$t('label.all_reasons')"
                                                    ></option>
                                                    <option v-for="(reason, index) in walletErrorReasons"
                                                            :value="reason"
                                                            :key="index"
                                                            v-text="walletErrorReasonsStr.get(reason)"
                                                    ></option>
                                                </kt-form-select>
                                            </kt-form-group>
                                        </kt-col>
                                        <kt-col xs="12" sm="3" md="3" class="mb-2">
                                            <kt-form-group>
                                                <kt-form-label for="from_date">
                                                    {{ $t('label.from_date') }}
                                                </kt-form-label>
                                                <button id="reset_from_date"
                                                        @click="clearFromDate"
                                                        class=" btn btn-label-danger trash-btn"
                                                >
                                                    <i class="la la-trash-o"></i>
                                                </button>
                                                <datePicker
                                                    format="YYYY-MM-DD HH:mm:ss"
                                                    display-format="dddd jDD jMMMM jYYYY HH:mm"
                                                    input-class="form-control"
                                                    id="from_date"
                                                    name= "from_date"
                                                    v-model="query.from_date"
                                                    type="datetime" />
                                            </kt-form-group>
                                        </kt-col>
                                        <kt-col xs="12" sm="3" md="3" class="mb-2">
                                            <kt-form-group>
                                                <kt-form-label for="to_date">
                                                    {{ $t('label.to_date') }}
                                                </kt-form-label>
                                                <button id="reset_to_date"
                                                        @click="clearToDate"
                                                        class=" btn btn-label-danger trash-btn"
                                                >
                                                    <i class="la la-trash-o"></i>
                                                </button>
                                                <datePicker
                                                    format="YYYY-MM-DD HH:mm:ss"
                                                    display-format="dddd jDD jMMMM jYYYY HH:mm"
                                                    input-class="form-control"
                                                    id="to_date"
                                                    name= "to_date"
                                                    v-model="query.to_date"
                                                    type="datetime"
                                                />
                                            </kt-form-group>
                                        </kt-col>
                                        <kt-col xs="12" sm="3" md="3" class="mb-2">
                                            <kt-form-group ref="bankNameSelectGroup">
                                                <kt-form-label for="bankName">
                                                    {{ $t('label.wallet_errors_columns.bank_name') }}
                                                </kt-form-label>
                                                <kt-form-select size="5" id="bankName" class="form-control"
                                                                name="bankName" v-model="query.bank_id"
                                                >
                                                    <option :value="null" v-text="$t('selectpicker.select_all')"
                                                    ></option>
                                                    <option v-for="(id, index) in bankId.mostUsedIds()"
                                                            :value="id"
                                                            :key="index"
                                                            v-text="bankIdStr.get(id)"
                                                    ></option>
                                                </kt-form-select>
                                            </kt-form-group>
                                        </kt-col>
                                        <kt-col xs="12" sm="3" md="3" class="mb-2">
                                            <kt-form-group ref="companySelectGroup">
                                                <kt-form-label for="company">
                                                    {{ $t('label.wallet_errors_columns.company') }}
                                                </kt-form-label>
                                                <kt-form-select size="5" id="company" class="form-control"
                                                                name="company" v-model="query.company_id"
                                                >
                                                    <option :value="null" v-text="$t('selectpicker.select_all')"
                                                    ></option>
                                                    <option v-for="(id, index) in companies"
                                                            :value="id"
                                                            :key="index"
                                                            v-text="companiesStr.get(id)"
                                                    ></option>
                                                </kt-form-select>
                                            </kt-form-group>
                                        </kt-col>
                                        <kt-col xs="12" sm="3" md="3" class="mb-2">
                                            <label for="request"
                                                   v-text="$t('label.wallet_errors_columns.request')"
                                            >
                                            </label>
                                            <input type="text"
                                                   id="request"
                                                   name= "request"
                                                   class="form-control"
                                                   v-model="query.request"
                                            >
                                        </kt-col>
                                        <kt-col xs="12" sm="3" md="3" class="mb-2">
                                            <label for="response"
                                                   v-text="$t('label.wallet_errors_columns.response')"
                                            >
                                            </label>
                                            <input type="text"
                                                   id="response"
                                                   name= "response"
                                                   class="form-control"
                                                   v-model="query.response"
                                            >
                                        </kt-col>
                                        <kt-col xs="12" sm="3" md="3" class="mb-2">
                                            <label for="duration_min"
                                                   v-text="$t('label.wallet_errors_columns.duration_min')"
                                            >
                                            </label>
                                            <input type="text"
                                                   id="duration_min"
                                                   name= "duration_min"
                                                   class="form-control"
                                                   v-model="query.duration_min"
                                            >
                                        </kt-col>
                                        <kt-col xs="12" sm="3" md="3" class="mb-2">
                                            <label for="duration_max"
                                                   v-text="$t('label.wallet_errors_columns.duration_max')"
                                            >
                                            </label>
                                            <input type="text"
                                                   id="duration_max"
                                                   name= "duration_max"
                                                   class="form-control"
                                                   v-model="query.duration_max"
                                            >
                                        </kt-col>
                                        <kt-col xs="12" sm="3" md="3" class="mb-2">
                                            <label for="wallet_bank_account_number"
                                                   v-text="$t('label.wallet_errors_columns.account_number')"
                                            >
                                            </label>
                                            <input type="text"
                                                   id="wallet_bank_account_number"
                                                   name= "wallet_bank_account_number"
                                                   class="form-control"
                                                   v-model="query.wallet_bank_account_number"
                                            >
                                        </kt-col>
                                        <kt-col xs="12" sm="3" md="3" class="mb-2">
                                            <label for="wallet_transaction_id"
                                                   v-text="$t('label.wallet_errors_columns.wallet_transaction_id')"
                                            >
                                            </label>
                                            <input type="text"
                                                   id="wallet_transaction_id"
                                                   name= "wallet_transaction_id"
                                                   class="form-control"
                                                   v-model="query.wallet_transaction_id"
                                            >
                                        </kt-col>
                                    </kt-form-row>
                                </kt-form-section>
                                <kt-form-section>
                                    <kt-row>
                                        <kt-col xs="12" sm="6" md="6" class="mt-4">
                                            <input type="submit" class="btn btn-success btn-wide" :value="$t('label.filter')">
                                        </kt-col>
                                    </kt-row>
                                </kt-form-section>
                            </form>
                        </div>
                    </div>
                </kt-panel>
            </div>
        </div>
        <kt-datatable ref="datatable" v-bind="datatableProps"></kt-datatable>
    </div>
</template>

<script>
import {ApiUrl} from "@/common/api.service";
import {AuthorizationHeader} from "@/common/jwt.service";
import columns from "../datatable/errors-columns.js";
import {
    walletErrorReasons, walletErrorReasonsStr,
    walletErrorStatus,
    walletErrorStatusStr, walletErrorStatusVariant,
    walletErrorTypes,
    walletErrorTypesStr, walletErrorTypesVariant
} from "@/constants/walletErrorsVariants";
import {bankId, bankIdStr} from "@/constants/bankId";
import {companies, companiesStr, companiesVariant} from "@/constants/companies";


export default {
    props: {
        api_base_path: {
            default: ApiUrl.path(''),
            type: String
        }
    },
    components: {
    },
    data() {
        return {
            query: {},
        };
    },
    methods: {
        walletErrorTypesVariant,
        walletErrorStatusVariant,
        companiesVariant,
        filterAction(e, query) {
            this.query = query;

            if (this.$refs.datatable.KTDatatable) {
                this.$refs.datatable.reload();
            }
        },
        clearFromDate() {
            if (this.query.from_date) {
                this.query.from_date = null;
            }
        },
        clearToDate() {
            if (this.query.to_date) {
                this.query.to_date = null;
            }
        },
    },
    computed: {
        walletErrorReasonsStr() {
            return walletErrorReasonsStr
        },
        walletErrorReasons() {
            return walletErrorReasons
        },
        companiesStr() {
            return companiesStr
        },
        companies() {
            return companies
        },
        bankIdStr() {
            return bankIdStr
        },
        bankId() {
            return bankId
        },
        walletErrorTypes() {
            return walletErrorTypes
        },
        walletErrorTypesStr() {
            return walletErrorTypesStr
        },
        walletErrorStatus() {
            return walletErrorStatus
        },
        walletErrorStatusStr() {
            return walletErrorStatusStr
        },
        datatableProps() {
            return {
                id: "wallets_errors_datatable",
                data: {
                    type: 'remote',
                    source: {
                        read: {
                            url: this.api_base_path + 'wallet/common/admin/errors',
                            method: 'GET',
                            headers: AuthorizationHeader,
                            map: res => {
                                return res.data.data;
                            },
                            params: this.query,
                        }
                    },
                    pageSize: 10,
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
                },
                layout: {},
                pagination: false,
                columns: columns,
            }
        },
    },
}
</script>
